import {
  BottomSheet,
  Illustration,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";

import { type PlacementCandidate } from "../../PlacementCandidate/types";
import { type PlacementWithDetails } from "../api/useFetchPaginatedPlacements";

interface ExternalApplicationConfirmationDialogProps {
  modalState: UseModalState;
  placement: PlacementWithDetails;
  placementCandidate: PlacementCandidate;
}

export function ExternalApplicationConfirmationDialog(
  props: ExternalApplicationConfirmationDialogProps
) {
  const { modalState, placement, placementCandidate } = props;

  const eventContext = {
    placement,
    placementCandidate,
  };

  const handleClose = () => {
    modalState.closeModal();
  };

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={handleClose} />}
      footer={
        <DialogFooter orientation="horizontal" sx={{ px: 8, pb: 8, pt: 2 }}>
          <Stack spacing={6} width="100%">
            <LoadingButton
              variant="contained"
              size="large"
              isLoading={false}
              onClick={() => {
                logEvent(
                  APP_V2_APP_EVENTS.EXTERNAL_APPLICATION_CONFIRMATION_DIALOG_ACK,
                  eventContext
                );
                modalState.closeModal();
              }}
            >
              Got it
            </LoadingButton>
          </Stack>
        </DialogFooter>
      }
    >
      <Box sx={{ px: 5, py: 6 }}>
        <Stack
          spacing={8}
          alignItems="center"
          justifyContent="center"
          sx={{ paddingX: 8, paddingTop: 6, paddingBottom: 10 }}
        >
          <Illustration type="request-sent" />
          <Stack spacing={6} textAlign="center">
            <Text variant="h2">Thanks for letting us know!</Text>
            <Text>
              <Box component="b" sx={{ fontWeight: 800 }}>
                Important Note:
              </Box>{" "}
              For roles marked &apos;Apply on Web&apos;, applications go directly to the workplace,
              not Clipboard. They may take 7+ days to respond.
            </Text>
          </Stack>
        </Stack>
      </Box>
    </BottomSheet>
  );
}
